import { CurriculumViewListing, CurriculumViewItem, SelfServiceGetLessonModel, LoginAsStudentModel, CurriculumViewGroup } from '../../../Elearning-Models';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { IServiceFactory } from '../../../Services/service-factory';
import { CurriculumService } from 'src/app/Services/curriculum.service';
import { CurriculumViewDetailsDialogComponent } from '../curriculum-view-details-dialog/curriculum-view-details-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { SimplePopupDialogComponent } from 'src/app/simple-popup-dialog/simple-popup-dialog.component';
import { environment } from 'src/environments/environment';
import { AssignmentAttemptsViewWorkDialogComponent } from '../../view-work/assignment-attempts-view-work-dialog/assignment-attempts-view-work-dialog.component';
@Component({
  selector: 'app-curriculum-view',
  templateUrl: './curriculum-view.component.html',
  styleUrls: ['./curriculum-view.component.scss'],
})
export class CurriculumViewComponent implements OnInit, OnDestroy {
  public dataService: CurriculumService;
  public curriculumViewData: CurriculumViewListing;
  public curriculumDataReceived: boolean = false;

  public showAll: boolean = true;

  public basicAndNeedsDiagnosticExamFirst = false;
  public justDemo:boolean = false;

  public loginAsStudentSpinner: boolean = false;

  public classID: any;

  imagePath = environment.imagePath + 'assets/images/curriculumImages/'

  constructor(
    private serviceFactory: IServiceFactory,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private toastr: ToastrService
  ) {
    this.dataService = serviceFactory.getCurriculumService();
  }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
      this.classID = params.get('classId');
      this.getCurriculumViewData();
    });
  }

  ngOnDestroy(): void {}

  /**
   * This method is used to get Curriculum View Data.
   */
  getCurriculumViewData = (): void => {
    this.curriculumDataReceived = false;
    this.dataService
      .GetCurriculumViewDataByClassId(this.classID)
      .subscribe((res) => {
        if (res) {
          this.curriculumViewData = res;
          this.curriculumViewData.Groups = this.curriculumViewData?.Groups?.filter(g => g.Items.length > 0);
          var isBasic = this.curriculumViewData.HasLessonMax;
          var needsDiagnostic = !this.curriculumViewData.HasCompletedPreCourseDiagnostic;
          this.justDemo = this.curriculumViewData.Groups == null;
          this.basicAndNeedsDiagnosticExamFirst = (isBasic && needsDiagnostic);
          this.curriculumDataReceived = true;
        }
      });
  };

  navigateStandardsGrowthReport(){
    this.router.navigate(['ELearning/CurriculumCourseStandardsReport'], {
      queryParams: {
        ClassID: this.classID
      },
    });
  }
  
  confirmLoginDialog(){
    const dialogRef = this.dialog.open(SimplePopupDialogComponent, {
      data: {
        okString: "Ok",
        title: "Login",
        cancelString: "Cancel",
        dialog: "Do you want to log in as " + this.curriculumViewData.StudentFullName +"?"
      },
    });

    const sub = dialogRef.componentInstance.valueUpdated.subscribe(
      (yes) => {
        if(yes){
          this.loginAsStudentSpinner = true;
          this.curriculumDataReceived = false;
          this.loginAsStudent();            
        }
      });

    dialogRef.afterClosed().subscribe((result) => {
      sub.unsubscribe();
    });
  }


  loginAsStudent(){

    var model = new LoginAsStudentModel();
    model.StudentID = this.curriculumViewData.StudentID;
    this.dataService.LoginAsStudent(model).subscribe(result => {
      if(result){
        window.location.reload();
      }
      else{
        this.toastr.error("Could not log in as student.", "Failed to log in as student");
      }
    });


  }

  /**
   * This method is used to redirect to external url.
   */
  redirectToExternalLink = (data: CurriculumViewItem, event): void => {
    event.cancelBubble = true;
    if (event.stopPropagation) event.stopPropagation();

    var externalURL = data.ExternalUrl;
    this.createModelAndGetStudentLesson(data.LessonID, externalURL);
  };

  redirectToPreDiagnosticExam(){

    this.curriculumDataReceived = false;
    if(this.curriculumViewData.IsTeacher){
      this.loginAsStudentSpinner = true;
    }

    var externalURL = "/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=";
   
    var lessonID = -1; // this is used for right now to tell the api it is for the diagnostic lesson
    var model = new SelfServiceGetLessonModel();
    model.ClassID = this.curriculumViewData.HBClassID;
    model.LessonID = lessonID;

    if(this.curriculumViewData.IsTeacher){
      this.dataService.LoginAndGetStudentDemo(model).subscribe( result => {
        if(result.Success){
          
          window.location.reload();
          externalURL = externalURL + result.AssignmentID;
          
          window.location.href= externalURL;
        }
        else{
          this.toastr.error(result.ErrorMessage, "Failed to start lesson.");
          this.curriculumDataReceived = true;
          this.loginAsStudentSpinner = false;
        }
      });
    }
    else{
      this.createModelAndGetStudentLesson(lessonID, externalURL);
    }
   
    
  }

  createModelAndGetStudentLesson(lessonID: number, externalURL: string){
    var model = new SelfServiceGetLessonModel();
    model.ClassID = this.curriculumViewData.HBClassID;
    model.LessonID = lessonID;
    this.dataService.GetStudentLesson(model).subscribe( result => {
      if(result.Success){

        externalURL = externalURL + result.AssignmentID;
        
        window.location.href= externalURL;
      }
      else{
        this.toastr.error(result.ErrorMessage, "Failed to start lesson.");
      }
    });
  }

  /**
   * This method is used to redirect to view work page.
   */
  redirectToViewWork = (data, event): void => {

    event.cancelBubble = true;
    if (event.stopPropagation) event.stopPropagation();

    const dialogRef = this.dialog.open(AssignmentAttemptsViewWorkDialogComponent, {
      data: {
        okString: "Close",
        cancelString: "",
        attemptID: data.CurrentAttemptID,
        assignmentID: data.AssignmentID,
        assignmentName: data.LessonName,
        studentName: this.curriculumViewData.StudentFullName,
        studentID: this.curriculumViewData.StudentID
      },
    });

    const sub = dialogRef.componentInstance.valueUpdated.subscribe(
      (yes) => {
        if(yes){

        }
      });

    dialogRef.afterClosed().subscribe((result) => {
      sub.unsubscribe();
    });

  };

  /**
   * This method is used to open dialog popup.
   */
  openDetailsDialog = (data) => {
    const dialogRef = this.dialog.open(CurriculumViewDetailsDialogComponent, {
      data: {
        curriculumData: data,
        title: data.LessonName + ' Details',
        studentName: this.curriculumViewData.StudentFullName,
        isTeacher: this.curriculumViewData.IsTeacher,
      },
    });

    //const sub = dialogRef.componentInstance.valueUpdated.subscribe();

    dialogRef.afterClosed().subscribe((result) => {
     // sub.unsubscribe();
    });
  };

  ///
    /**
   * This method is used to open dialog popup.
   */
  confirmLoginDemoDialog(event){
    event.cancelBubble = true;
    if (event.stopPropagation) event.stopPropagation();

    if(this.curriculumViewData.IsTeacher){
      const dialogRef = this.dialog.open(SimplePopupDialogComponent, {
        data: {
          okString: "Ok",
          title: "Login",
          cancelString: "Cancel",
          dialog: "Do you want to log in as " + this.curriculumViewData.StudentFullName +"?"
        },
      });
  
      const sub = dialogRef.componentInstance.valueUpdated.subscribe(
        (yes) => {
          if(yes){
            this.redirectToPreDiagnosticExam();            
          }
        });
  
      dialogRef.afterClosed().subscribe((result) => {
        sub.unsubscribe();
      });
    }
    else{
      this.redirectToPreDiagnosticExam();
    }
    
  };

  goToFreeDiagMarketReport($event){
    
  }

  onExpandCollapseAll(){
    if(this.showAll){
      this.curriculumViewData.Groups.forEach(g => g.Hide = true);
    }
    else{      
      this.curriculumViewData.Groups.forEach(g => g.Hide = false);
    }
    this.showAll = !this.showAll;

  }


  expandCollapseUnit(unit: CurriculumViewGroup){
    unit.Hide = !unit.Hide;
  }

  countSuggestedItems(unit: CurriculumViewGroup){
    return unit.Items.filter(i => i.Suggested).length;
  }
}
